<template>
  <div class="mb-10">
    <v-card class="mx-auto pa-3" outlined>
      <v-card-title>اطلاعات شرکت</v-card-title>
      <v-alert dense outlined type="error" v-if="errored">
        {{ errorMessage }}
      </v-alert>
      <v-card-text>
        <v-form
          v-model="isFormValid"
          ref="form"
          @submit.prevent="handleAddCompany"
        >
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="name"
                :rules="nameRules"
                label="نام"
                type="text"
                prepend-icon="mdi-form-textbox"
                outlined
                dense
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="moderator"
                :rules="moderatorRules"
                label="نام مدیر"
                type="text"
                prepend-icon="mdi-card-account-details-outline"
                outlined
                dense
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-select
                v-model="type"
                :items="typeItems"
                :item-text="typeItems.text"
                :item-value="typeItems.value"
                label="نوع فعالیت"
                prepend-icon="mdi-format-list-bulleted-type"
                outlined
                dense
                required
              ></v-select>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="tel"
                :rules="telRules"
                label="تلفن"
                type="text"
                prepend-icon="mdi-phone-outline"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="fax"
                label="فکس"
                type="text"
                prepend-icon="mdi-fax"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-file-input
                v-model="logo"
                show-size
                truncate-length="15"
                accept="image/png, image/jpeg"
                label="بارگذاری تصویر"
                outlined
                dense
              ></v-file-input>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="email"
                label="ایمیل"
                type="text"
                prepend-icon="mdi-mail"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="website"
                label="وبسایت"
                type="text"
                prepend-icon="mdi-web"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="9">
              <v-text-field
                v-model="address"
                label="آدرس"
                type="text"
                prepend-icon="mdi-map-marker"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="postalcode"
                label="کد پستی"
                type="text"
                prepend-icon="mdi-numeric"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="product"
                :rules="productRules"
                label="محصولات"
                type="text"
                prepend-icon="mdi-package-variant-closed"
                outlined
                dense
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="category"
                :items="categories"
                :item-text="categories.text"
                :item-value="categories.value"
                label="دسته بندی"
                multiple
                chips
                hint="دسته بندی را انتخاب نمایید"
                persistent-hint
              ></v-select>
            </v-col>
            <v-col>
              <v-textarea
                v-model="description"
                label="توضیحات"
                type="text"
                prepend-icon="mdi-text"
                outlined
                dense
              ></v-textarea>
            </v-col>
          </v-row>
          <v-btn
            :loading="loading"
            :disabled="!isFormValid || loading"
            color="secondary"
            type="submit"
            @click="createDialog = false"
            block
          >
            <span slot="loader" class="custom-loader">
              <v-icon light>cached</v-icon>
            </span>
            ثبت اطلاعات
          </v-btn>
        </v-form>
        <div class="text-center mt-3">
          <v-btn
            small
            text
            color="error"
            router
            :to="{ name: 'AdminCompanies' }"
          >
            بازگشت
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
export default {
  name: "Edit",
  data() {
    return {
      isFormValid: true,
      loading: false,
      errored: false,
      errorMessage: "",
      name: "",
      nameRules: [(name) => !!name || "نام شرکت اجباری است"],
      moderator: "",
      moderatorRules: [(moderator) => !!moderator || "نام مدیر اجباری است"],
      tel: "",
      telRules: [(tel) => !!tel || "تلفن اجباری است"],
      fax: "",
      logo: null,
      type: "",
      typeItems: [
        { text: "پلاستیک، لاستیک و کامپوزیت", value: "plastic" },
        { text: "پوشرنگ، رزین و چسب", value: "glue" },
        { text: "بسته بندی", value: "packing" }
      ],
      email: "",
      website: "",
      address: "",
      postalcode: "",
      product: "",
      productRules: [(products) => !!products || "لیست محصولات اجباری است"],
      description: "",
      category: [],
      categories: []
    };
  },
  created() {
    this.handleGetCompany();
  },
  methods: {
    handleGetCompany() {
      const companyId = this.$route.params.id;
      this.$api.get("/company/" + companyId).then((res) => {
        const company = res.data.company;
        this.name = company.name;
        this.moderator = company.moderator;
        this.tel = company.tel;
        this.fax = company.fax;
        this.type = company.type;
        this.email = company.email;
        this.website = company.website;
        this.address = company.address;
        this.postalcode = company.postalcode;
        this.product = company.product;
        this.description = company.description;
        this.category = company.categories;
        this.category = company.categories;
      });
      this.$api.get("categories/all").then((res) => {
        const categories = res.data.categories;
        categories.forEach((element) => {
          this.categories.push({
            text: element.name,
            value: element._id
          });
        });
      });
    },
    handleAddCompany() {
      const companyId = this.$route.params.id;
      this.$api
        .patch("/company/" + companyId, {
          name: this.name,
          moderator: this.moderator,
          tel: this.tel,
          fax: this.fax,
          type: this.type,
          email: this.email,
          website: this.website,
          address: this.address,
          postalcode: this.postalcode,
          product: this.product,
          description: this.description,
          categories: this.category
        })
        .then((res) => {
          if (this.logo) {
            const imageApiUrl = "company/" + res.data._id + "/image";
            let formData = new FormData();
            formData.append("image", this.logo);
            this.$api.post(imageApiUrl, formData).catch((error) => {
              this.errored = true;
              this.errorMessage = error;
            });
          }
          this.$router.push({ name: "AdminCompanies" });
        })
        .catch((error) => {
          this.errored = true;
          this.errorMessage = error;
        });
    }
  }
};
</script>
